module.exports = require("npm:util@0.10.3/util.js");